import { EntityType } from '@frontend/common';
import { NotificationClient } from '@frontend/notification/api';
import { useResolver } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';

declare global {
    interface WindowEventMap {
        'useNotification:request': CustomEvent<string>;
    }
}

const REQUEST_NOTIFICATION_EVENT = 'useNotification:request';
const STORAGE_KEY = 'NOTIF_REQ';

export function notificationRequest(notificationId: string): string {
    window.dispatchEvent(new CustomEvent(REQUEST_NOTIFICATION_EVENT, { detail: notificationId }));
    return STORAGE_KEY + '_loading';
}

interface Props {
    dispatch: ThunkDispatch<any, any, Action>;
}

/** Seeds resolved notifications into the shared resolve store. Required for reactive notification details. */
export function NotificationResolver(props: Props) {
    useResolver(STORAGE_KEY, REQUEST_NOTIFICATION_EVENT, EntityType.NOTIFICATION, (ids) => NotificationClient.resolveNotifications(ids), props.dispatch);
    return null;
}
